import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { BaseListComponent } from '../../shared/base-list/base-list.component';

@Component({
  selector: 'app-base-user-list',
  templateUrl: '../../shared/base-list/base-list.component.html',
  styleUrls: ['../../shared/base-list/base-list.component.scss']
})
export class BaseUserListComponent extends BaseListComponent implements OnInit, OnChanges {
  @Input() userid: any;
  async ngOnInit() {
    await super.ngOnInit();
    this.pageTitle = `${this.selectedAccount ? this.selectedAccount : this.translator.instant('APP_NAME')} :: ${this.userid || ''} :: ${this.meta?.caption}`;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.userid && this.meta) {
      this.pageTitle = `${this.selectedAccount ? this.selectedAccount : this.translator.instant('APP_NAME')} :: ${this.userid || ''} :: ${this.meta?.caption}`;
      this.load();
    }
  }

}
